<template>
    <div class="sm:ml-2 lg:ml-12" ref="observerElement">
        <transition name="slide-up" appear v-if="isVisible">

            <h1 class="font-futura text-navy text-4xl sm:text-5xl md:text-7xl mt-32 ">2025 TOP 10 SELECTED STARTUPS </h1>

        </transition>

        <div class="grid grid-cols-2 mr-4 ml-4 lg:ml-0 lg:mr-12 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 mt-12">
            <ul v-for="startup in startups" :key="startup.name" class="border border-lightTangerine p-4 min-h-[220px]">
                <div class="flex h-full flex-col items-center justify-center text-center">
                    <transition name="fade-slide-right" appear v-if="isVisible">
                        <div class="startup-logo-box mt-2 mb-4">
                            <img :src="startup.icon" :alt="startup.name + ' logo'" class="startup-logo" />
                        </div>
                    </transition>
                    <transition name="fade-slide-right" appear v-if="isVisible">
                        <h1 class="font-futura text-navy text-xl sm:text-2xl mt-2 leading-tight break-words">{{ startup.name }}</h1>
                    </transition>
                    <transition name="fade-slide-right" appear v-if="isVisible">
                        <h3 class="font-gramatika text-navy text-md mt-2">{{ startup.category }}
                        </h3>
                    </transition>
                </div>
            </ul>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Top45Of2025',
    data() {
        return {
            startups: [
            { name: 'AFROTAG', category: 'Digital', icon: require('../assets/2025-startups/afrotag.png') },
            { name: 'ALL GREEN', category: 'Green', icon: require('../assets/2025-startups/all-green.png') },
            { name: 'AMBUCYCLE LTD', category: 'Health', icon: require('../assets/2025-startups/ambucycle.png') },
            // { name: 'AXK ICON', category: 'Product', icon: require('../assets/2025-startups/axk-icon.png') },
            { name: 'CREDITRACK', category: 'Fintech', icon: require('../assets/2025-startups/credi-track.png') },
            { name: 'DI-FARM', category: 'Agriculture', icon: require('../assets/2025-startups/difarm.png') },
            { name: 'DURABLOC', category: 'Construction', icon: require('../assets/2025-startups/durabloc.png') },
            // { name: 'ESHURI', category: 'Fintech', icon: require('../assets/2025-startups/eshuri.svg') },
            { name: 'EXAMIRA', category: 'Education', icon: require('../assets/2025-startups/examira.png') },
            { name: 'FEED PLANT', category: 'Agriculture', icon: require('../assets/2025-startups/feed-plant.png') },
            { name: 'GERAYO', category: 'Digital', icon: require('../assets/2025-startups/gerayo.png') },
            { name: 'HOME OF GOOD SERVICES', category: 'Services', icon: require('../assets/2025-startups/hgs.png') },
            // { name: 'INSYT AI', category: 'Digital', icon: require('../assets/2025-startups/insyt.webp') },
            { name: 'KESHO', category: 'Fintech', icon: require('../assets/2025-startups/kesho.png') },
            { name: 'NEEM COMPANY', category: 'Health', icon: require('../assets/2025-startups/neem.png') },
            { name: 'MPOST', category: 'Digital', icon: require('../assets/2025-startups/mpost.png') },
            { name: 'NABSIL GRAIN BANK', category: 'Agriculture', icon: require('../assets/2025-startups/nabsil.png') },
            { name: 'BAHO NURSEBOT', category: 'Health', icon: require('../assets/2025-startups/baho-nurse-bot.png') },
            // { name: 'PEBLA', category: 'Digital', icon: require('../assets/2025-startups/pebla.svg') },
            // { name: 'REALM', category: 'Real Estate', icon: require('../assets/2025-startups/realm.png') },
            { name: 'RE-BANATEX', category: 'Agriculture', icon: require('../assets/2025-startups/rebanatex.png') },
            { name: 'SMART SCHOOL', category: 'Education', icon: require('../assets/2025-startups/smart-school.png') },
            // { name: 'WEKRAFT', category: 'Product', icon: require('../assets/2025-startups/wekraft.svg') },
            { name: 'WESPERR', category: 'Digital', icon: require('../assets/2025-startups/wesperr.png') },
            { name: 'ZAZU MANUFACTURING', category: 'Green', icon: require('../assets/2025-startups/zazu.png') },
            ],
            isVisible: false
        };
    },
    mounted() {
        this.initiativeAnimations();
    },
    methods: {
        initiativeAnimations() {
            const observer = new IntersectionObserver((entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting) {
                        this.isVisible = true;
                    }
                });
            });

            observer.observe(this.$refs.observerElement);
        },
    }
}
</script>

<style>
.startup-logo {
    width: 100%;
    height: 100%;
    object-fit: contain;
}

.startup-logo-box {
    align-items: center;
    display: flex;
    height: 72px;
    justify-content: center;
    max-width: 150px;
    width: 100%;
}

.fade-in {
    opacity: 0;
    transition: opacity 1.2s ease-in-out;
}

.fade-in-visible {
    opacity: 1;
}

.slide-up-enter-active,
.slide-left-enter-active,
.slide-right-enter-active {
    transition: all 0.7s ease-out;
}

.slide-up-enter-from {
    opacity: 0;
    transform: translateY(50px);
}

.slide-up-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.slide-left-enter-from {
    opacity: 0;
    transform: translateX(-50px);
}

.slide-left-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.slide-right-enter-from {
    opacity: 0;
    transform: translateX(50px);
}

.slide-right-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.6s ease-in-out;
}

.fade-enter,
.fade-leave-to {
    opacity: 0;
}

.fade-slide-up-enter-active {
    transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-up-enter-from {
    opacity: 0;
    transform: translateY(50px);
}

.fade-slide-up-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.fade-slide-left-enter-active {
    transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-left-enter-from {
    opacity: 0;
    transform: translateX(-80px);
}

.fade-slide-left-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.fade-slide-right-enter-active {
    transition: all 1s cubic-bezier(0.42, 0, 0.58, 1);
}

.fade-slide-right-enter-from {
    opacity: 0;
    transform: translateX(80px);
}

.fade-slide-right-enter-to {
    opacity: 1;
    transform: translateX(0);
}

.zoom-enter-active {
    transition: all 0.7s ease;
}

.zoom-enter-from {
    opacity: 0;
    transform: scale(0.9);
}

.zoom-enter-to {
    opacity: 1;
    transform: scale(1);
}

.fade-slide-up-enter-active,
.fade-slide-up-leave-active {
    transition: opacity 1.1s ease-in-out, transform 1.1s ease-in-out;
}

.fade-slide-up-enter-from {
    opacity: 0;
    transform: translateY(50px);
}

.fade-slide-up-enter-to {
    opacity: 1;
    transform: translateY(0);
}

.fade-slide-up-leave-from {
    opacity: 1;
    transform: translateY(0);
}

.fade-slide-up-leave-to {
    opacity: 0;
    transform: translateY(80px);
}
</style>
